import RecurrenceList from './RecurrenceList';

export default RecurrenceList;
